import VesselProperty from "./Enums/VesselProperty";

const VesselPathConfig = {
	messageProperties: [
		VesselProperty.MMSI,
		VesselProperty.TIMESTAMP,
		VesselProperty.FLAG,
		VesselProperty.SPEED,
		VesselProperty.COURSE
	],
	pointProperties: {
		[VesselProperty.NAME]: VesselProperty.NAME,
		[VesselProperty.IMO]: VesselProperty.IMO,
		iconImage: (stop) => {
			return (typeof stop.properties[VesselProperty.COURSE] !== "undefined") ? "path-triangle-isosceles" : "dot-11";
		}
	},
	pointLiveGetterProperties: {

	},
	historicOrder: -1
};
export default VesselPathConfig;
